// extracted by mini-css-extract-plugin
module.exports = {"content":"content___i-C54","container":"container___1NbY8","title":"title___1PFDp"};